(function () {
    'use strict';

    angular.module('GorillaBoy.FeatureManager')
    /**
     * @ngdoc directive
     * @name featureManagerDirective
     *
     * @description
     * Directive used to determine whether to show the element based on a feature flag from the service.
     * Do not use this directive for modals in our webapp - use ng-if instead (See the gb-generate-link-modal element in components/file-browser/modals.html).
     */
    .directive('featureManager', ['$parse', 'FeatureManagerService',
        function ($parse, FeatureManagerService) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                // We only set isNewFeature to false if the new-feature attribute explicitly sets it to false. Otherwise, it is set to true.
                var isNewFeature = angular.isDefined(attrs.newFeature) ? scope.$eval(attrs.newFeature) : true,
                    isFeatureEnabled = FeatureManagerService.isFeatureEnabled(attrs.featureManager),
                    el = angular.element(element);

                // Show the element if the feature is enabled and the element is part of the new feature, OR
                // show the element if the feature is disabled and the element is from the old feature.
                if ((isFeatureEnabled && isNewFeature) || (!isFeatureEnabled && !isNewFeature)) {
                    el.show();
                } else {
                    el.hide();
                }
            }
        };
    }]);
}());